import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FileProps } from '@/context/FileContext/types';

import { IConversion } from '@/pages/Partners/types/apis/indications';

export interface Questions {
  doesThePropertyHaveFurniture: boolean;
  isThePropertyUnderConstruction: boolean;
  isTheOwnerAwareOfTheIndication: boolean;
  IsIndicatedWithinSeazoneOperationArea: boolean;
}

export type KeyQuestions = keyof Questions;

export interface OpenModalWithFilesProps {
  is: boolean;
  uploadKey: string;
}

export interface IndicateState {
  questions: Questions;
  files: { [key: string]: FileProps[] };
  openModalWithFiles: OpenModalWithFilesProps;
  conversion: IConversion;
}

const initialConversion: IConversion = { progress: 20, isMaxBar: true };

const initialQuestions: Questions = {
  doesThePropertyHaveFurniture: false,
  IsIndicatedWithinSeazoneOperationArea: false,
  isTheOwnerAwareOfTheIndication: false,
  isThePropertyUnderConstruction: false,
};

const initialState: IndicateState = {
  questions: initialQuestions,
  files: {},
  openModalWithFiles: {
    is: false,
    uploadKey: '',
  },
  conversion: initialConversion,
};

const indicateSlice = createSlice({
  name: 'indicate',
  initialState,
  reducers: {
    setQuestions(state, action: PayloadAction<Questions>) {
      state.questions = action.payload;
    },
    updateQuestion(state, action: PayloadAction<{ key: keyof Questions; value: boolean }>) {
      state.questions[action.payload.key] = action.payload.value;
    },
    setFiles(state, action: PayloadAction<{ [key: string]: FileProps[] }>) {
      state.files = action.payload;
    },
    addFile(state, action: PayloadAction<{ key: string; file: FileProps }>) {
      const { key, file } = action.payload;
      if (!state.files[key]) {
        state.files[key] = [];
      }
      state.files[key].push(file);
    },
    setOpenModalWithFiles(state, action: PayloadAction<OpenModalWithFilesProps>) {
      state.openModalWithFiles = action.payload;
    },
    setConversion(state, action: PayloadAction<IConversion>) {
      state.conversion = action.payload;
    },
    resetIndicateState(state) {
      state.questions = initialQuestions;
      state.files = {};
      state.openModalWithFiles = { is: false, uploadKey: '' };
      state.conversion = initialConversion;
    },
  },
});

export const {
  setQuestions,
  updateQuestion,
  setFiles,
  addFile,
  setOpenModalWithFiles,
  resetIndicateState,
  setConversion,
} = indicateSlice.actions;
export default indicateSlice.reducer;
